import { render, staticRenderFns } from "./XPagination.vue?vue&type=template&id=8adf36da"
import script from "./XPagination.vue?vue&type=script&lang=js"
export * from "./XPagination.vue?vue&type=script&lang=js"
import style0 from "./XPagination.vue?vue&type=style&index=0&id=8adf36da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports